import Carousel from "@/src/components/common/carousel";
import Image from "next/image";
import BlogList from "../blog/blogList";
const HomeBlog = ({ blogs }) => {
    return (
        <div className="bg-gray-100 py-8">
            <div className="max-w-6xl mx-auto">
                <h2 className="md:text-left text-center md:text-2xl text-xl font-bold text-black md:mb-6 mb-2">
                    Blogs
                </h2>

                <Carousel
                    settings={{
                        infinite: true,
                        speed: 700,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        // centerMode: true,
                        responsive: [
                            {
                                breakpoint: 600,
                                settings: {
                                    slidesToShow: 1,
                                },
                            },
                        ],
                    }}
                >
                    {blogs?.length > 0 &&
                        blogs.map((item, index) => (
                            <BlogList
                                key={index}
                                item={item}
                                isSpacing={true}
                            />
                        ))}
                </Carousel>
            </div>
        </div>
    );
};

export default HomeBlog;
